module.exports = __webpack_public_path__ + "assets/img/tx12g_1.25505793.jpg";